<form [formGroup]="skjema" data-testid="skjema">
  <div>
    @for (kontroller of skjema.controls; track indeks; let indeks = $index; let erSisteRad = $last) {
      <div class="aksjeklasse-rediger-rad"
           [class]="{slettet: kontroller.value.slettet, arkivert: kontroller.value.arkivert}"
           data-testid="rad">
        <div class="aksjeklasse-felt-gruppe">
          <mat-form-field class="navn">
            <mat-label>
              @if (kontroller.value.ny) {
                {{ 'Ny aksjeklasse' | translate }}
              } @else {
                {{ 'Navn' | translate }}
              }
            </mat-label>
            <input matInput [formControl]="kontroller.controls.tittel" name="tittel" data-testid="navn-felt">
            @if (kontroller.controls.tittel.hasError('duplikat')) {
              <mat-error>{{ 'Duplikate navn er ikke tillatt' | translate }}</mat-error>
            }
          </mat-form-field>

          @if (!erSisteRad) {
            <mat-form-field class="beskrivelse">
              <mat-label>{{ 'Beskrivelse' | translate }}</mat-label>
              <riktekst-redigering [skjemakontroll]="kontroller.controls.beskrivelse" data-testid="beskrivelse-felt"/>
            </mat-form-field>
          }
        </div>

        <div class="handling" [class.skjult]="erSisteRad">
          @if (kontroller.value.arkivert) {
            <button mat-stroked-button type="button"
                    (click)="reaktiver(kontroller)"
                    [matTooltip]="'Aksjeklassen er arkivert. Reaktiver den for å gjøre den tilgjengelig igjen.' | translate">
              {{ 'Reaktiver' | translate }}
            </button>
          } @else if (kontroller.value.slettet) {
            <button mat-stroked-button type="button" (click)="angreSlett(kontroller)">
              {{ 'Angre' | translate }}
            </button>
          } @else if (kontroller.value.iBrukIBeholdning) {
            <button mat-stroked-button type="button"
                    (click)="arkiver(kontroller)"
                    [matTooltip]="'Aksjeklassen er i bruk og kan ikke slettes, kun arkiveres.' | translate">
              {{ 'Arkiver' | translate }}
            </button>
          } @else {
            <button mat-icon-button type="button" (click)="slett(kontroller, indeks)" aria-label="Slett aksjeklasse" data-testid="slett-knapp">
              <mat-icon fontSet="ion-ios-trash-outline" class="mat-icon--ionic-ikon"/>
            </button>
          }
        </div>
      </div>
    }
  </div>

  <kort-handlinger>
    <button mat-button type="button" (click)="avbryt()">{{ 'Avbryt' | translate }}</button>
    <button mat-raised-button color="primary" type="submit" (click)="lagre()"
            [disabled]="lagrer() || skjema.invalid">{{ 'Lagre' | translate }}</button>
  </kort-handlinger>
</form>
